export function isAssessment(formSchemaId) {
  return [
    4000000000000000, 4000000000000001, 4000000000000002, 4000000000000003,
    4000000000000004, 4000000000000005, 4000000000000006, 4000000000000007,
    4000000000000008, 4000000000000009, 4000000000000010, 4000000000000011,
    4000000000000012, 4000000000000013, 4000000000000014, 4000000000000015,
  ].includes(formSchemaId);
}
